

const progressBar = document.getElementById('ebProgress');

window.addEventListener('scroll', () => {
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const scrollTop = document.documentElement.scrollTop;
    const scrollPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;
    progressBar.style.width = scrollPercent + '%';
});
document.addEventListener('DOMContentLoaded', () => {
    const article = document.querySelector('#article-rte');
    const articleContent = document.querySelector('#article-content');
    const toc = document.querySelector('#table-of-contents');

    if (!article || !toc) return;

    let ul = document.createElement('ul');
    ul.id = 'navigator';
    ul.className = 'toc-list flex flex-col gap-4';
    toc.appendChild(ul);

    const headings = Array.from(article.querySelectorAll('h2'));
    if (!headings.length) return;

    const tocItems = [];
    let isClicking = false;

    let lastActiveIndex = 0;

    function detectDirection(newIndex) {
        if (newIndex === lastActiveIndex) return;

        if (newIndex > lastActiveIndex) {
            toc.classList.remove('active-up');
            toc.classList.add('active-down');
        } else {
            toc.classList.remove('active-down');
            toc.classList.add('active-up');
        }

        lastActiveIndex = newIndex;
    }

    headings.forEach((h2, index) => {
        if (!h2.id) {
            let id = h2.textContent
                .trim()
                .toLowerCase()
                .replace(/[^\w\s-]/g, '')
                .replace(/\s+/g, '-');
            h2.id = `${id}-${index}`;
        }

        const li = document.createElement('li');
        li.className = 'toc-item pl-5 relative';

        const a = document.createElement('a');
        a.href = `#${h2.id}`;
        a.textContent = h2.textContent;
        a.className = 'block';
        a.addEventListener('click', (e) => {
            e.preventDefault();
            isClicking = true;
            tocItems.forEach((item) => item.classList.remove('active'));
            li.classList.add('active');
            detectDirection(index);
            const rect = h2.getBoundingClientRect();
            const container = articleContent;

            if (container.scrollHeight > container.clientHeight) {
                const containerTop = container.getBoundingClientRect().top;
                const offset = rect.top - containerTop + container.scrollTop;
                container.scrollTo({ top: offset, behavior: 'smooth' });
            } else {
                let offsetTop = window.scrollY + rect.top - 80;
                if (toc.classList.contains('active-up')) {
                    offsetTop = window.scrollY + rect.top - 200;
                }
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth',
                });
            }

            setTimeout(() => {
                isClicking = false;
            }, 400);
        });

        li.appendChild(a);
        ul.appendChild(li);
        tocItems.push(li);
    });

    // --- SCROLL ACTIVE ---
    function updateActive() {
        if (isClicking) return;

        const container = articleContent;
        const isInsideScroll = container.scrollHeight > container.clientHeight;

        let centerY = isInsideScroll
            ? container.getBoundingClientRect().top + container.clientHeight / 2
            : window.innerHeight / 2;

        let bestIndex = 0;
        let bestDistance = Infinity;

        headings.forEach((h, idx) => {
            const rect = h.getBoundingClientRect();
            const mid = rect.top + rect.height / 2;
            const dist = Math.abs(mid - centerY);

            if (dist < bestDistance) {
                bestDistance = dist;
                bestIndex = idx;
            }
        });

        tocItems.forEach((li, idx) => li.classList.toggle('active', idx === bestIndex));

        detectDirection(bestIndex);
    }

    const container = articleContent;
    if (container.scrollHeight > container.clientHeight) {
        container.addEventListener('scroll', updateActive, { passive: true });
    } else {
        window.addEventListener('scroll', updateActive, { passive: true });
    }

    updateActive();
});


document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.accordion-details');
    accordions.forEach((details) => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('.accordion-details__content');
        const baseHeight =
            summary.offsetHeight +
            parseInt(getComputedStyle(details).paddingTop) +
            parseInt(getComputedStyle(details).paddingBottom);
        details.dataset.baseHeight = baseHeight;
        if (!details.hasAttribute('open')) {
            details.style.height = baseHeight + 'px';
            content.style.opacity = 0;
            content.style.pointerEvents = 'none';
        }

        summary.addEventListener('click', (e) => {
            e.preventDefault();

            if (!details.hasAttribute('open')) {
                accordions.forEach((other) => {
                    if (other !== details && other.hasAttribute('open')) {
                        const otherContent = other.querySelector('.accordion-details__content');
                        closeAccordion(other, otherContent);
                    }
                });
            }

            if (details.hasAttribute('open')) {
                closeAccordion(details, content);
            } else {
                openAccordion(details, content);
            }
        });
    });

    function openAccordion(details, content) {
        const base = parseInt(details.dataset.baseHeight);
        const contentHeight = content.scrollHeight;

        details.setAttribute('open', '');
        details.setAttribute('aria-expanded', 'true');
        details.style.height = base + 'px';

        content.style.opacity = 0;
        content.style.pointerEvents = 'none';

        requestAnimationFrame(() => {
            details.style.transition = 'height 0.25s ease';
            content.style.transition = 'opacity 0.2s ease';

            details.style.height = base + contentHeight + 'px';
            content.style.opacity = 1;
            content.style.pointerEvents = 'auto';
        });

        details.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'height') {
                details.style.height = 'auto';
                details.removeEventListener('transitionend', handler);
            }
        });
    }

    function closeAccordion(details, content) {
        const base = parseInt(details.dataset.baseHeight);
        const fullHeight = details.scrollHeight;

        details.style.height = fullHeight + 'px';
        details.setAttribute('aria-expanded', 'false');

        requestAnimationFrame(() => {
            details.style.transition = 'height 0.25s ease';
            content.style.transition = 'opacity 0.2s ease';

            details.style.height = base + 'px';
            content.style.opacity = 0;
            content.style.pointerEvents = 'none';
        });

        details.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'height') {
                details.removeAttribute('open');
                details.removeEventListener('transitionend', handler);
            }
        });
    }
});
const navigatorEl = document.querySelector('#table-of-contents');

document.addEventListener('DOMContentLoaded', () => {
    const navigatorEl = document.querySelector('#table-of-contents');
    const bannerEl = document.querySelector('.banner-article-ads');
    console.log(navigatorEl)
    if (!navigatorEl) return;
    if (!bannerEl) return;
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {

        const currentY = window.scrollY;
        const isDesktop = window.innerWidth >= 1024;
        if (isDesktop) {
            if (currentY > lastScrollY) {
                navigatorEl.classList.add('compact');
                bannerEl.classList.add('compact');
            } else {
                navigatorEl.classList.remove('compact');
                bannerEl.classList.remove('compact');
            }
        }
        lastScrollY = currentY <= 0 ? 0 : currentY;
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const banners = document.querySelectorAll('.eb-banner-inview');
    const body = document.body;

    const options = {
        root: null,
        threshold: 1
    };
    const header = document.querySelector('header');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                body.classList.add('has-focus');
                header?.classList.add('is-focused');
                entry.target.classList.add('is-focused');
            } else {
                entry.target.classList.remove('is-focused');
                const anyFocused = document.querySelector('.eb-banner-inview.is-focused');
                if (!anyFocused) {
                    body.classList.remove('has-focus');
                    header?.classList.remove('is-focused');
                }
            }
        });
    }, options);

    banners.forEach(banner => observer.observe(banner));
});